import { addBlankLine } from "./addBlankLine.js";
function addSection(section, state) {
  return addBlankLine(state) + section;
}
export {
  addSection
};
//# sourceMappingURL=addSection.js.map
